import { CallDetailsCustomerDetails } from './call_details_customer_details';
import { CallDetailsPhotosNotesModelLegacy } from './call_details_photos_notes';
import { PageWrapper } from '../page_wrapper';
import { NoReservationCallDetailsWithNoteEditor } from './no_reservation_call_details_with_note_editor';
import { CallDetailMediaGallery } from '../reservation/call_detail_media_gallery';
import { CallDetailModelSerialNumbers } from '../reservation/call_detail_model_serial_numbers';
import { useCompanySettingsStore } from '../../../hooks/use_global_context';

// This view was added to display the new WYSISYG editor in the legacy view.
// Bug: If Expert Enalbed is OFF, AHSEnabled is off, customer details will display twice. ST-9162

export const LegacyCallDetailContent = ({ readOnly }: { readOnly?: boolean }): JSX.Element => {
    const companySettings = useCompanySettingsStore();
    const noteEditorEnabled = companySettings.editorNotesEnabled;

    const content = noteEditorEnabled ? (
        <NotesEnabledContents readOnly={readOnly} />
    ) : (
        <NotesDisabledContents readOnly={readOnly} />
    );

    return (
        <PageWrapper data-testid="call-details">
            <CallDetailsCustomerDetails />

            {content}
        </PageWrapper>
    );
};

const NotesEnabledContents = ({ readOnly }: { readOnly?: boolean }) => {
    return (
        <>
            <NoReservationCallDetailsWithNoteEditor />
            <CallDetailMediaGallery readOnly={readOnly} />
            <CallDetailModelSerialNumbers />
        </>
    );
};

const NotesDisabledContents = ({ readOnly }: { readOnly?: boolean }) => {
    return <CallDetailsPhotosNotesModelLegacy readOnly={readOnly} />;
};
